<template>
  <div class="keyword_search">
    <v-text-field
        @input="search($event)"
        required
        outlined
        dense
        clearable
        :placeholder='$t("Введите текст")'
    />
    <div v-if="searchText && searchText.length > 2">
      <v-treeview
        v-if="searchResultList.length > 0"
        v-model="searchModel"
        style="overflow-y: scroll; height: 150px;"
        :items="searchResultList"
        :label="$t('Ключевые слова')"
        :selection-type="'independent'"
        selectable
      />
      <div v-else>
        Ничего не найдено
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'KeywordSearch',
  props: {
    searchData: {
      type: [Array, Object],
      required: true
    }
  },
  data () {
    return {
      searchResultList: [],
      searchText: '',
      searchModel: []
    }
  },
  watch: {
    searchModel: {
      handler (val) {
        if (val) {
          this.$emit('input', val)
        }
      }
    }
  },
  methods: {
    search (text) {
      this.searchResultList = []
      this.searchText = text

      if (text != '' && text.length > 2) {
        this.searchData.forEach(item => {
          if (item.children?.length > 0) {
            item.children.forEach(itemChildren => {
              if (itemChildren.name.toLowerCase().indexOf(text.toLowerCase()) != -1) {
                if (!this.searchResultList[itemChildren.parent]) {
                  this.searchResultList[itemChildren.parent] = this.searchData.find(item => item.id == itemChildren.parent)
                  this.searchResultList[itemChildren.parent].children = []
                  this.searchResultList[itemChildren.parent].children.push(itemChildren)
                } else {
                  this.searchResultList[itemChildren.parent].children.push(itemChildren)
                }
              }
            })
          }
        });
      }

      this.$forceUpdate();
    }
  }
}
</script>
<style lang="scss" scoped>
  .keyword_search {
    width: 100%;
  }
</style>